var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSeen = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 10.352,
    viewBox: "0 0 18 10.352",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_46769",
    "data-name": "Path 46769",
    d: "M13.6,127.307l-1.082-1.082-4.867,4.867,1.082,1.082Zm3.245-1.082L8.73,134.414l-3.245-3.245L4.4,132.251l4.326,4.326,9.27-9.27ZM0,132.251l4.326,4.326L5.408,135.5l-4.326-4.326Z",
    transform: "translate(0 -126.225)",
    fill: "#00a1af"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSeen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_seen.387a43ee056a4cf4956a4e2b1627e7cb.svg";